/**
 * Copyright © Veeam Software Group GmbH.
 */

import { EOrganizationMfaPolicyStatusRepresentation } from '@veeam-vspc/models/web-controllers';

export type CompanyMfaStatuses = EOrganizationMfaPolicyStatusRepresentation;
export const CompanyMfaStatuses = EOrganizationMfaPolicyStatusRepresentation;
